import React from "react";

export default ({ large }) => (
  <img src="/logo.png" srcSet="/logo@2x.png 2x" alt="EventLive" height={50} />
);
